import { isMobile } from "utils/userAgent";

const GOOGLE_ANALYTICS_ID: string | undefined =
	process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
if (typeof GOOGLE_ANALYTICS_ID === "string") {
} else {
}
